import { StackScreenProps } from "@react-navigation/stack";
import { Page, TextField, Button } from "@towersystems/roam-common-native";
import { useCallback, useEffect, useMemo, useState } from "react";
import { SettingsRootParamList } from "../../../../types";
import {
  useGlobalSettingsProvider,
  useMutationUpdateGlobalSettings,
} from "../../../../utilities/global-settings/hooks";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { DynamicMobileText } from "../../../../components/DynamicMobileText";
import { useCurrentVendorProvider } from "../../../../utilities/vendor";
import { AccountCountryType } from "@towersystems/roam-common/lib/generated-types";

export interface EditBusinessAbnScreenProps
  extends StackScreenProps<SettingsRootParamList, "EditBusinessAbnScreen"> {}

export const EditBusinessAbnScreen = ({
  navigation,
}: EditBusinessAbnScreenProps) => {
  const shouldFocus = useHasTransitionEnded(navigation);
  const globalSettings = useGlobalSettingsProvider();
  const { updateGlobalSettings } = useMutationUpdateGlobalSettings();
  const { currentVendor } = useCurrentVendorProvider();
  const { abn = "" } = globalSettings;
  const [value, setValue] = useState(abn || "");

  const taxLabel =
    currentVendor.countryType === AccountCountryType.AUSTRALIA
      ? "ABN"
      : "GST Number";

  const isDirty = useMemo(() => {
    return value != abn;
  }, [value, abn]);

  const isValid = useMemo(() => {
    return true;
  }, [value]);

  const handleOnSave = useCallback(async () => {
    if (!isValid) return;
    return updateGlobalSettings({
      abn: value,
    })
      .then((e) => navigation.goBack())
      .catch((err) => console.log(err));
  }, [value, isValid]);

  useEffect(() => {
    const disabled = !isDirty || !isValid;
    navigation.setOptions({
      headerTitleAlign: "center",
      headerTitle: () => <DynamicMobileText label={`Edit ${taxLabel}`} />,
      headerStatusBarHeight: 10,
      headerRight: () => {
        return (
          <Button
            label="Save"
            isAction
            disabled={disabled}
            onPress={handleOnSave}
            size="compact"
          ></Button>
        );
      },
    });
  }, [isValid, handleOnSave, isDirty, taxLabel]);

  return (
    <Page scrollable={false} cover>
      <TextField
        placeholder={taxLabel}
        value={value}
        onChangeText={(v) => setValue(v)}
        autoFocus={shouldFocus}
      />
    </Page>
  );
};
